export const yes_no = [
  {
    value: "Yes",
    name: "Yes",
  },
  {
    value: "No",
    name: "No",
  },
];

export default yes_no;



// WEBPACK FOOTER //
// ./src/constants/yes_no.js